// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"12f8008b","239":"e39fb35b","455":"df5fe32a","578":"eece98a5","977":"23814c44"}[chunkId] + ".chunk.js";
};